export const blockBuilder = {
	selector: {
		own: '.js-block-builder',
		switch: '.js-block-builder-switch',
		sortable: '.js-block-builder-sortable',
		section: 'data-block-builder-section',
		sectionActivator: 'data-block-builder-section-activator',
		flipper: 'data-m-activator-full-page-handler',
	},
}
